import React, { useEffect } from 'react';
import { Result, Spin } from 'antd';

const StripeAccountLinkReturnPage = () => {
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    // Simulate a brief loading state
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
      <Result
        status="success"
        title="Account Setup Complete"
        subTitle="Your Stripe account has been successfully set up. You can now receive payments."
      />
    </div>
  );
};

export default StripeAccountLinkReturnPage;
